import { useEffect, useState } from "react";
import { api, formatBRL } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/admin/orders").then(({ data }) => setOrders(data.slice(0, 5))).catch(() => {});
  }, []);
  if (!stats) return <div className="text-[#49392F]/70">Carregando...</div>;

  const cards = [
    { label: "Pedidos", value: stats.total_orders },
    { label: "Pendentes", value: stats.pending_orders },
    { label: "Faturamento", value: formatBRL(stats.revenue) },
    { label: "Produtos ativos", value: stats.total_products },
    { label: "Clientes", value: stats.total_customers },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl text-[#49392F]">Visão geral</h1>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-8">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-[#C2A064]/20 p-5">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C2A064]">{c.label}</div>
            <div className="font-display text-2xl text-[#49392F] mt-2">{c.value}</div>
          </div>
        ))}
      </div>

      <h2 className="font-display text-xl text-[#49392F] mt-12 mb-4">Últimos pedidos</h2>
      <div className="bg-white border border-[#C2A064]/20">
        {orders.length === 0 ? (
          <div className="p-6 text-[#49392F]/70">Nenhum pedido ainda.</div>
        ) : (
          <table className="w-full text-[13px]">
            <thead className="text-left text-[#49392F]/70">
              <tr><th className="p-3">Número</th><th className="p-3">Cliente</th><th className="p-3">Status</th><th className="p-3 text-right">Total</th></tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} className="border-t border-[#C2A064]/10">
                  <td className="p-3">{o.order_number}</td>
                  <td className="p-3">{o.customer?.name}</td>
                  <td className="p-3">{o.status_label}</td>
                  <td className="p-3 text-right">{formatBRL(o.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
